export enum BRAND_ATTRIBUTES {
  ASIAN_OWNED = "asian_owned",
  BLACK_OWNED = "black_owned",
  /**
   * @deprecated use GIVES_BACK instead.
   */
  CHARITABLE = "charitable",
  ECO_FRIENDLY = "eco_friendly",
  GIVES_BACK = "gives_back",
  HAND_MADE = "hand_made",
  LATINO_OWNED = "latino_owned",
  LGBTQ_OWNED = "lgbtq_owned",
  LOW_MINIMUM = "low_minimum",
  MADE_IN_AUSTRALIA = "made_in_australia",
  MADE_IN_AUSTRIA = "made_in_austria",
  MADE_IN_BELGIUM = "made_in_belgium",
  MADE_IN_CANADA = "made_in_canada",
  MADE_IN_DENMARK = "made_in_denmark",
  MADE_IN_EUROPE = "made_in_europe",
  MADE_IN_FINLAND = "made_in_finland",
  MADE_IN_FRANCE = "made_in_france",
  MADE_IN_GERMANY = "made_in_germany",
  MADE_IN_IRELAND = "made_in_ireland",
  MADE_IN_ITALY = "made_in_italy",
  MADE_IN_LUXEMBOURG = "made_in_luxembourg",
  MADE_IN_NETHERLANDS = "made_in_netherlands",
  MADE_IN_NORWAY = "made_in_norway",
  MADE_IN_PORTUGAL = "made_in_portugal",
  MADE_IN_SPAIN = "made_in_spain",
  MADE_IN_SWEDEN = "made_in_sweden",
  MADE_IN_SWITZERLAND = "made_in_switzerland",
  MADE_IN_UK = "made_in_uk",
  MADE_IN_USA = "made_in_usa",
  NOT_SOLD_ON_AMAZON = "not_sold_on_amazon",
  ORGANIC = "organic",
  /**
   * @deprecated no direct replacement, avoid using.
   */
  SMALL_BATCH = "small_batch",
  SHOP_LOCAL = "shop_local",
  WOMEN_OWNED = "women_owned",
}
